export function getDomElement(selector) {
  return document.querySelector(selector);
}

export const attachEventListener = (event, callback) => {
  window.addEventListener(event, callback);
};

export const removeEventListener = (event, callback) => {
  window.removeEventListener(event, callback);
};

export const calculateScrollPosition = () => {
  const supportPageOffset = window.pageXOffset !== undefined;
  const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

  const scrollTop = supportPageOffset
    ? window.pageYOffset
    : isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  return parseInt(scrollTop, 10);
};

export const isIE11 = () => /Trident\/|MSIE/.test(window.navigator.userAgent);
